<web-settings-breadcrumbs>
    <div class="breadcrumb-icon">
        <a
            role="button"
            tabindex="0"
            [attr.aria-label]="'back' | translate"
            (click)="onCancel()"
            (keydown.enter)="onCancel()"
            (keydown.space)="$event.preventDefault(); onCancel()"
        >
            <img src="./assets/img/websites/lpc-back-icon.svg" class="first-breadcrumb-icon" alt="" />
        </a>
    </div>
    <div class="breadcrumb-text">
        <span>{{ "control_tab_styles" | translate }}</span>
    </div>
</web-settings-breadcrumbs>

<div class="panel-options-body overflow-wrapper" cdkTrapFocus [cdkTrapFocusAutoCapture]="true">
    <form class="form form-horizontal" (submit)="$event.preventDefault()">
        <div class="form-row">
            <div class="form-group mb-20">
                <label class="col-xs-12">
                    {{ "control_text" | translate }}
                </label>
                <div class="col-xs-12">
                    <input class="form-control" [formField]="titleField()" />
                </div>
            </div>
        </div>
    </form>
</div>

<web-settings-footer (saveEvent)="onSave()" (cancelEvent)="onReset()"></web-settings-footer>
